import { useSearchParams } from "react-router-dom";

// CIP / O&P / All view toggle driven by the ?family= query param.
export function FamilyToggle({ testid = "family-toggle" }) {
  const [sp, setSp] = useSearchParams();
  const cur = sp.get("family") || "all";
  const set = (v) => {
    const n = new URLSearchParams(sp);
    if (v === "all") n.delete("family"); else n.set("family", v);
    setSp(n, { replace: true });
  };
  const opts = [["all", "All"], ["cip", "CIP"], ["op", "O&P"]];
  return (
    <div className="inline-flex border border-border rounded overflow-hidden" data-testid={testid}>
      {opts.map(([v, l]) => (
        <button key={v} type="button" onClick={() => set(v)} data-testid={`${testid}-${v}`}
          className={`px-3 py-1 text-xs font-semibold transition-colors ${
            cur === v ? "bg-foreground text-background" : "bg-transparent text-muted-foreground hover:bg-secondary"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
